module.exports = __webpack_public_path__ + "img/chat-dots-fill.dfd0b08a.svg";